import { combineReducers } from 'redux'
import { reducer as reduxFormReducer } from 'redux-form'
import { reducer as api } from 'redux-json-api'
import currentUserReducer from './containers/PrivateRoute/reducers'
import modulesReducer from './containers/ModuleFetchContainer/reducers'
import modulesRoutingReducer from './containers/ModulesRoutingContainer/reducers'
import studentGroupingsReducer from './containers/StudentGroupingsContainer/reducers'
import courseFormReducer from './containers/CourseFormContainer/reducers'
import sectionFormReducer from './containers/SectionFormContainer/reducers'
import studentFormReducer from './containers/StudentFormContainer/reducers'
import casReducer from './containers/CASContainer/reducers'
import googleOAuthReducer from './containers/GoogleOAuthContainer/reducers'
import assignmentsReducer from './containers/AssignmentFetchContainer/reducers'
import familyRoutingReducer from './containers/FamilyRoutingContainer/reducers'
import familyDashboardReducer from './containers/FamilyDashboardContainer/reducers'
import trackProgressRoutingReducer from './containers/TrackProgressRoutingContainer/actions'
import filterReducer from './containers/FilterContainer/actions'
import calendarReducer from './pages/calendar/actions'
// JSONAPI Redux extensions
// See https://github.com/redux-json-api/redux-json-api/issues/24 for
// implementation details.
import { reducer } from 'redux-json-api'
import reduceReducers from 'reduce-reducers'
import { createAction } from 'redux-actions'

// Hacky solution for dropping deleted assignments from the state
// after an instructor deletes them.
// TODO: continue this work to add the ability to clear the state to allow the calendar to re-fetch the assignment data
// A re-fetch of assignments is needed after this dispatch.

/*const apiReducer = reduceReducers(
  reducer,
  handleAction(CLEAR_ASSIGNMENTS, state => {
    let newState = JSON.parse(JSON.stringify(state))
    delete newState['assignments']
    return newState
  }
)*/


const rootReducer = combineReducers({
  form:                 reduxFormReducer,
  api:                  api,
  currentUser:          currentUserReducer,
  modules:              modulesReducer,
  modulesRouting:       modulesRoutingReducer,
  studentGroupings:     studentGroupingsReducer,
  courseForm:           courseFormReducer,
  sectionForm:          sectionFormReducer,
  studentForm:          studentFormReducer,
  cas:                  casReducer,
  googleOAuth:          googleOAuthReducer,
  assignments:          assignmentsReducer,
  familyRouting:        familyRoutingReducer,
  familyDashboard:      familyDashboardReducer,
  trackProgressRouting: trackProgressRoutingReducer,
  filter:               filterReducer,
  calendar:             calendarReducer
})

export default rootReducer
